// extracted by mini-css-extract-plugin
export default {"errorContainer":"errorContainer__YqqN8MwcEU","title":"title__qx9hBii8Fe","button":"button__DLO2dVKifF"};